import React from "react"
import "./navigational-card-container.scss"
import NavigationalCardItem from "./navigational-card-item"

function NavigationalCardContainer({ contentArea }) {
  return (
    <section className="navigational-card-container w--normal">
      <div className="grid">
        {contentArea.map((item, index) => {
          return <NavigationalCardItem item={item} key={index} />
        })}
      </div>
    </section>
  )
}

export default NavigationalCardContainer
